import React from 'react';
import PageHeader from '../components/PageHeader';
import ServicesSection from '../components/ServicesSection';
import ServicesDeepDive from '../components/ServicesDeepDive';
import CTABoxes from '../components/CTABoxes';

const ServicesPage = () => {
  return (
    <>
      <PageHeader
        eyebrow="What We Offer"
        title="Our Services"
        description="Comprehensive plumbing and roofing solutions for residential and commercial properties across Melbourne."
      />
      <ServicesSection />
      <ServicesDeepDive />
      <CTABoxes />
    </>
  );
};

export default ServicesPage;
